S.list = {
    config: {
        filter: 0,
        action: 'list',
    },

    elements: {
        $listContainer: null,
        $loadButton: null,
        $showAllFilter: null,
        $button: null,
        $teaser: null,
        $filter: null,
        $eventFilter: null,
    },

    originFilter: null,
    currentFilter: null,
    page: null,
    renewList: true,

    init()
    {
        this.elements.$eventFilter.hide();
        // set initial value for next page to load
        if (!this.page)
        {
            this.page = 2;
        }
        this.originFilter = this.elements.$listContainer.data('type');


        if (this.config.action === 'filter')
        {
            this.elements.$loadButton.on('click', (event) =>
            {
                this.renewList = false;
                this.currentFilter = this.elements.$listContainer.data('type');
                this.loadArticles($(event.currentTarget).data('showEvents'));
                this.page++;
            });
        }

        this.initFilters();
    },

    loadArticles(showEvents)
    {
        const container = this.elements.$listContainer;
        const loadButton = this.elements.$loadButton;
        const ajaxUrl = container.attr('data-ajaxUrl');
        const storagePid = container.attr('data-storagepid');
        const data = {};

        data['tx_project_articlefilter[page]'] = this.page;
        data['tx_project_articlefilter[type]'] = this.currentFilter;
        data['tx_project_articlefilter[more]'] = true;
        data['tx_project_articlefilter[storagePid]'] = storagePid;
        data['tx_project_articlefilter[showEvents]'] = showEvents;

        $.ajax({
            url: ajaxUrl,
            type: 'POST',
            data: data,
            cache: false,
            success: (data) =>
            {
                // HTML Output
                if (this.renewList)
                {
                    container.html($(data).find('.m-main').html());
                    this.page++;
                }
                else
                {
                    container.append($(data).find('.m-main').html());
                }
                if ($(data).find('.m-load-button').hasClass('is-hidden'))
                {
                    loadButton.hide();
                }
                else
                {
                    loadButton.show();
                }
            },
            error: (e) =>
            {
                // eslint-disable-next-line no-console
                console.log(e, 'error');
            },
        });
    },

    initFilters()
    {
        this.elements.$button.on('click', (e) =>
        {
            this.page = 1;
            this.renewList = true;
            this.elements.$loadButton.data('showEvents', 0);
            if ($(e.target).hasClass('is-active'))
            {
                $(e.target).removeClass('is-active');
                this.resetFilter();
            }
            else
            {
                this.elements.$button.each(function ()
                {
                    $(this).removeClass('is-active');
                });

                $(e.target).addClass('is-active');
                const $that = $(e.target);

                this.elements.$listContainer.data('type', $that.data('filter'));
                this.currentFilter = $that.data('filter');

                if (this.config.action === 'filter')
                {
                    this.loadArticles(0);
                }
                else if (this.config.action === 'list')
                {
                    this.elements.$teaser.removeClass('is-hidden');
                    this.elements.$teaser.each((key, e) =>
                    {
                        const articleTypes = $(e).attr('data-type').split(' ');

                        if (!articleTypes.includes($that.data('filter').toString()))
                        {
                            $(e).addClass('is-hidden');
                        }
                    });
                }
            }
            this.checkColor();
        });
    },

    resetFilter()
    {
        this.elements.$eventFilter.hide();
        this.elements.$listContainer.data('type', this.originFilter);
        this.currentFilter = this.originFilter;

        if (this.config.action === 'filter')
        {
            this.loadArticles(1);
        }
        else if (this.config.action === 'list')
        {
            this.elements.$teaser.removeClass('is-hidden');
        }
    },

    checkColor()
    {
        let filer = 0;

        this.elements.$filter.children().each(function ()
        {
            if ($(this).children().length)
            {
                $(this).removeClass('is-active is-inactive');
                $(this).has('.is-active').addClass('is-active');
                $(this).not('.is-active').addClass('is-inactive');
            }

            if ($(this).is('.is-active'))
            {
                filer = 1;
            }
        });

        if (!filer)
        {
            this.elements.$filter.children().each(function ()
            {
                $(this).removeClass('is-inactive');
            });
        }

        const event = ($('.mod-teaser-standard-triple .m-mask.is-active').first().attr('data-name'));

        if ((event === 'Events') || (event === 'Veranstaltungen'))
        {
            this.elements.$eventFilter.show();
            this.elements.$listContainer.hide();
        }
        else
        {
            this.elements.$eventFilter.hide();
            this.elements.$listContainer.show();
        }
    },
};
